module.exports = __webpack_public_path__ + "static/media/roof-3.1f47c50f.jpg";